import React from 'react';
import { FacebookIcon, TwitterIcon, MailIcon } from 'lucide-react';
export function SocialShare() {
  return <div className="flex flex-wrap gap-3 my-8 justify-center border-t border-b border-gray-200 py-4" data-id="element-122">
      <button className="flex items-center px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded text-sm" onClick={e => e.preventDefault()} data-id="element-123">
        <FacebookIcon size={16} className="mr-2" data-id="element-124" />
        Share on Facebook
      </button>
      <button className="flex items-center px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded text-sm" onClick={e => e.preventDefault()} data-id="element-125">
        <TwitterIcon size={16} className="mr-2" data-id="element-126" />
        Share on Twitter
      </button>
      <button className="flex items-center px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded text-sm" onClick={e => e.preventDefault()} data-id="element-127">
        <MailIcon size={16} className="mr-2" data-id="element-128" />
        Email This Article
      </button>
    </div>;
}